// extracted by mini-css-extract-plugin
export default {"container":"receipt_container__bmLDh"};